"use strict";

var _regeneratorRuntime = require("/home/cjh/tmp/edp/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchFetchOauthProviders = watchFetchOauthProviders;
exports.watchTestOauthEnabled = watchTestOauthEnabled;
exports.watchNewToken = watchNewToken;
exports.watchAuthenticate = watchAuthenticate;
exports.watchInvalidateToken = watchInvalidateToken;
exports.watchFetchMe = watchFetchMe;
exports.watchUsernameLogin = watchUsernameLogin;
exports.watchNerscLogin = watchNerscLogin;
exports.watchLoadTokenFromApiKey = watchLoadTokenFromApiKey;

require("regenerator-runtime/runtime");

var _effects = require("redux-saga/effects");

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _lodashEs = require("lodash-es");

var _auth = require("../../ducks/auth");

var _auth2 = require("../../rest/auth");

var _girderClient = _interopRequireDefault(require("@openchemistry/girder-client"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(fetchOauthProviders),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchFetchOauthProviders),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(testOauthEnabled),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchTestOauthEnabled),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchNewToken),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(authenticate),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchAuthenticate),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(invalidateToken),
    _marked9 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchInvalidateToken),
    _marked10 =
/*#__PURE__*/
_regeneratorRuntime.mark(fetchMe),
    _marked11 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchFetchMe),
    _marked12 =
/*#__PURE__*/
_regeneratorRuntime.mark(usernameLogin),
    _marked13 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchUsernameLogin),
    _marked14 =
/*#__PURE__*/
_regeneratorRuntime.mark(nerscLogin),
    _marked15 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchNerscLogin),
    _marked16 =
/*#__PURE__*/
_regeneratorRuntime.mark(loadTokenFromApiKey),
    _marked17 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchLoadTokenFromApiKey);

function fetchOauthProviders(action) {
  var providers;
  return _regeneratorRuntime.wrap(function fetchOauthProviders$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)((0, _auth.requestOauthProviders)());

        case 3:
          _context.next = 5;
          return (0, _effects.call)(_auth2.fetchProviders, action.payload);

        case 5:
          providers = _context.sent;
          _context.next = 8;
          return (0, _effects.put)((0, _auth.receiveOauthProviders)(providers));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          _context.next = 14;
          return (0, _effects.put)((0, _auth.requestOauthProviders)(_context.t0));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 10]]);
}

function watchFetchOauthProviders() {
  return _regeneratorRuntime.wrap(function watchFetchOauthProviders$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_auth.LOAD_OAUTH_PROVIDERS, fetchOauthProviders);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function testOauthEnabled() {
  return _regeneratorRuntime.wrap(function testOauthEnabled$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_auth2.fetchProviders, 'dummy');

        case 3:
          _context3.next = 5;
          return (0, _effects.put)((0, _auth.setOauthEnabled)(true));

        case 5:
          _context3.next = 11;
          break;

        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 11;
          return (0, _effects.put)((0, _auth.setOauthEnabled)(false));

        case 11:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 7]]);
}

function watchTestOauthEnabled() {
  return _regeneratorRuntime.wrap(function watchTestOauthEnabled$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_auth.TEST_OAUTH_ENABLED, testOauthEnabled);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function updateToken(action) {
  var girderToken = action.payload;

  if (girderToken !== null) {
    (0, _girderClient.default)().updateToken(girderToken);
  }

  var cookies = new _universalCookie.default();
  cookies.set('girderToken', girderToken, {
    path: '/'
  });
}

function watchNewToken() {
  return _regeneratorRuntime.wrap(function watchNewToken$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_auth.SET_TOKEN, updateToken);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function authenticate(action) {
  var payload, token, redirect, me, auth, _redirect;

  return _regeneratorRuntime.wrap(function authenticate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = action.payload;
          token = payload.token;
          redirect = payload.redirect;
          _context6.next = 5;
          return (0, _effects.put)((0, _auth.setAuthenticating)(true));

        case 5:
          me = null;
          auth = false;

          if ((0, _lodashEs.isNil)(token)) {
            _context6.next = 19;
            break;
          }

          _context6.next = 10;
          return (0, _effects.call)(_auth2.fetchMe, token);

        case 10:
          me = _context6.sent;

          if (!(me != null)) {
            _context6.next = 19;
            break;
          }

          _context6.next = 14;
          return (0, _effects.put)((0, _auth.setToken)(token));

        case 14:
          _context6.next = 16;
          return (0, _effects.put)((0, _auth.setMe)(me));

        case 16:
          _context6.next = 18;
          return (0, _effects.put)((0, _auth.setAuthenticating)(false));

        case 18:
          auth = true;

        case 19:
          if (auth) {
            _context6.next = 28;
            break;
          }

          if (!redirect) {
            _context6.next = 26;
            break;
          }

          _redirect = window.location.href;
          _context6.next = 24;
          return (0, _effects.put)((0, _auth.loadOauthProviders)(_redirect));

        case 24:
          _context6.next = 28;
          break;

        case 26:
          _context6.next = 28;
          return (0, _effects.put)((0, _auth.setAuthenticating)(false));

        case 28:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchAuthenticate() {
  return _regeneratorRuntime.wrap(function watchAuthenticate$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeEvery)(_auth.AUTHENTICATE, authenticate);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function invalidateToken(action) {
  return _regeneratorRuntime.wrap(function invalidateToken$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.put)((0, _auth.requestInvalidateToken)());

        case 3:
          _context8.next = 5;
          return (0, _effects.call)(_auth2.invalidateToken);

        case 5:
          _context8.next = 7;
          return (0, _effects.put)((0, _auth.setToken)(null));

        case 7:
          _context8.next = 9;
          return (0, _effects.put)((0, _auth.receiveMe)(null));

        case 9:
          _context8.next = 15;
          break;

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 15;
          return (0, _effects.put)((0, _auth.requestInvalidateToken)(_context8.t0));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, this, [[0, 11]]);
}

function watchInvalidateToken() {
  return _regeneratorRuntime.wrap(function watchInvalidateToken$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_auth.INVALIDATE_TOKEN, invalidateToken);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function fetchMe(action) {
  var me;
  return _regeneratorRuntime.wrap(function fetchMe$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.put)((0, _auth.requestMe)());

        case 3:
          _context10.next = 5;
          return (0, _effects.call)(_auth2.fetchMe);

        case 5:
          me = _context10.sent;
          _context10.next = 8;
          return (0, _effects.put)((0, _auth.receiveMe)(me));

        case 8:
          _context10.next = 14;
          break;

        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](0);
          _context10.next = 14;
          return (0, _effects.put)((0, _auth.requestMe)(_context10.t0));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10, this, [[0, 10]]);
}

function watchFetchMe() {
  return _regeneratorRuntime.wrap(function watchFetchMe$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeEvery)(_auth.LOAD_ME, fetchMe);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function usernameLogin(action) {
  var _action$payload, username, password, resolve, reject, res, token, me;

  return _regeneratorRuntime.wrap(function usernameLogin$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _action$payload = action.payload, username = _action$payload.username, password = _action$payload.password, resolve = _action$payload.resolve, reject = _action$payload.reject;
          _context12.prev = 1;
          _context12.next = 4;
          return (0, _effects.call)(_auth2.logIn, username, password);

        case 4:
          res = _context12.sent;
          token = res.authToken.token;
          _context12.next = 8;
          return (0, _effects.put)((0, _auth.setToken)(token));

        case 8:
          me = res.user;
          _context12.next = 11;
          return (0, _effects.put)((0, _auth.setMe)(me));

        case 11:
          _context12.next = 13;
          return (0, _effects.put)((0, _auth.setAuthenticating)(false));

        case 13:
          // yield put(showGirderLogin(false));
          if (resolve) {
            resolve();
          }

          _context12.next = 19;
          break;

        case 16:
          _context12.prev = 16;
          _context12.t0 = _context12["catch"](1);

          if (reject) {
            reject('Unable to login with the provided credentials');
          }

        case 19:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12, this, [[1, 16]]);
}

function watchUsernameLogin() {
  return _regeneratorRuntime.wrap(function watchUsernameLogin$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeEvery)(_auth.USERNAME_LOGIN, usernameLogin);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function nerscLogin(action) {
  var _action$payload2, username, password, mfa, resolve, reject, _ref, auth, newt_sessionid, me, cookies, token;

  return _regeneratorRuntime.wrap(function nerscLogin$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _action$payload2 = action.payload, username = _action$payload2.username, password = _action$payload2.password, mfa = _action$payload2.mfa, resolve = _action$payload2.resolve, reject = _action$payload2.reject;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.call)(_auth2.nerscLogIn, username, password, mfa);

        case 4:
          _ref = _context14.sent;
          auth = _ref.auth;
          newt_sessionid = _ref.newt_sessionid;

          if (auth) {
            _context14.next = 9;
            break;
          }

          throw Error('Invalid username or password.');

        case 9:
          _context14.next = 11;
          return (0, _effects.call)(_auth2.authenticateWithNewt, newt_sessionid);

        case 11:
          me = _context14.sent;
          cookies = new _universalCookie.default();
          token = cookies.get('girderToken');
          _context14.next = 16;
          return (0, _effects.put)((0, _auth.setToken)(token));

        case 16:
          _context14.next = 18;
          return (0, _effects.put)((0, _auth.setMe)(me));

        case 18:
          _context14.next = 20;
          return (0, _effects.put)((0, _auth.setAuthenticating)(false));

        case 20:
          // yield put(showNerscLogin(false));
          if (resolve) {
            resolve();
          }

          _context14.next = 26;
          break;

        case 23:
          _context14.prev = 23;
          _context14.t0 = _context14["catch"](1);

          if (reject) {
            reject('Unable to login with the provided credentials');
          }

        case 26:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14, this, [[1, 23]]);
}

function watchNerscLogin() {
  return _regeneratorRuntime.wrap(function watchNerscLogin$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeEvery)(_auth.NERSC_LOGIN, nerscLogin);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function loadTokenFromApiKey(action) {
  var key, tokenResponse;
  return _regeneratorRuntime.wrap(function loadTokenFromApiKey$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          key = action.payload;
          _context16.next = 4;
          return (0, _effects.call)(_auth2.fetchTokenFromApiKey, key);

        case 4:
          tokenResponse = _context16.sent;
          _context16.next = 7;
          return (0, _effects.put)((0, _auth.setToken)(tokenResponse.token));

        case 7:
          _context16.next = 13;
          break;

        case 9:
          _context16.prev = 9;
          _context16.t0 = _context16["catch"](0);
          _context16.next = 13;
          return (0, _effects.put)((0, _auth.requestTokenFromApiKey)(_context16.t0));

        case 13:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16, this, [[0, 9]]);
}

function watchLoadTokenFromApiKey() {
  return _regeneratorRuntime.wrap(function watchLoadTokenFromApiKey$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeEvery)(_auth.LOAD_TOKEN_FROM_API_KEY, loadTokenFromApiKey);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17, this);
}